// extracted by mini-css-extract-plugin
export default {"newApp":"zSflbV0HlhSYADu86-F4cQ==","loadingStyle":"Cz2K1NwSjUBPEbg+xDuUJQ=="};